import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import { HashRouter, Routes, Route, Navigate, BrowserRouter } from "react-router-dom";
import { initializeIcons } from "@fluentui/react";

import "./index.css";
import Chat from "./pages/chat/chat";
import { KPMGLogo } from "./icons/icon";
import Auth from "./pages/auth/auth"
import { reAuth, getUser, use_token } from "./api";

initializeIcons();

export default function App() {
    const [logoClicked, setLogoClicked] = useState(false);
    const [appTitleVisible, setAppTitleVisible] = useState (false);

    const handleLogoClick = (event: any) => {
        event.stopPropagation();
        setLogoClicked(prev => !prev);
    };

    const getApi = async() => {
        const get_link = await reAuth();
        console.log("checkuser2")
        window.location.href = get_link.auth_url
    }

    const checkUser = async() => {
        console.log("checkuser1")
        const user = await getUser();
        console.log(user.message,"user.message")
        if(user.message == "success"){
        }else{
            getApi()
        }
    }

    useEffect(() => {
        if(use_token){
            let token = localStorage.getItem("token")
            console.log("checkuser token", token)
            if(window.location.pathname != "/auth" && window.location.pathname != "/auth/sso"){
                if(token == null){
                    getApi()
                }else{
                    checkUser()
                }
            }
        }
    }, [])
    
    return (
        <BrowserRouter>
            {/* <header>
                <span style={{ cursor: "pointer", marginRight: "15px" }} onClick={handleLogoClick}>
                    {KPMGLogo()}
                </span>
                {appTitleVisible && <span style={{fontSize:"16px", color:"rgba(47, 47, 57, 1)"}}>Requirements Elicitation Agent</span>}
            </header> */}
            <Routes>
                <Route path="/auth" element={<Auth logoClicked={logoClicked} setLogoClicked={setLogoClicked} appTitleVisible ={appTitleVisible} setAppTitleVisible={setAppTitleVisible} />}></Route>
                <Route path="/auth/sso" element={<Auth logoClicked={logoClicked} setLogoClicked={setLogoClicked} appTitleVisible ={appTitleVisible} setAppTitleVisible={setAppTitleVisible} />}></Route>
                <Route path="/" element={<Chat logoClicked={logoClicked} setLogoClicked={setLogoClicked} appTitleVisible={appTitleVisible} setAppTitleVisible={setAppTitleVisible} />}></Route>
            </Routes>
        </BrowserRouter>

    );
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(<App />);
